import React, { useEffect, useState } from "react";

const ThankYouModal = ({ isOpen, onClose }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Trigger animation when modal opens
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
      }, 3000); // Animation duration
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Background overlay with fade-in */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300"></div>

      {/* Modal container */}
      <div className="flex min-h-screen items-center justify-center p-4 text-center">
        {/* Modal content with slide-in and bounce animation */}
        <div 
          className={`transform transition-all duration-300 
            ${isAnimating ? 'scale-110' : 'scale-100'}
            w-full max-w-md overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl`}
        >
          {/* Animated checkmark */}
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <svg
              className={`h-6 w-6 text-green-600 ${isAnimating ? 'animate-bounce' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          {/* Thank you message */}
          <div className="mt-3 text-center">
            <h3 className="text-lg font-medium leading-6 text-gray-900">
              Thank You!
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                We appreciate your submission. Our team will get back to you soon.
              </p>
            </div>
          </div>

          {/* Close button */}
          <div className="mt-4 flex justify-center">
            <button
              type="button"
              className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 transition-colors duration-200"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal; 
